<div class="skeleton-loader" [ngSwitch]="variant" role="status" aria-label="Loading">
    <div *ngSwitchCase="'form'" class="skeleton-form">
        <div class="skeleton-form-row" *ngFor="let row of rowsArray()">
            <div class="skeleton-bar skeleton-label"></div>
            <div class="skeleton-bar skeleton-input"></div>
        </div>
    </div>
    <div *ngSwitchCase="'block'" class="skeleton-blocks">
        <div class="skeleton-bar skeleton-block" *ngFor="let row of rowsArray()"></div>
    </div>
    <div *ngSwitchDefault class="skeleton-lines">
        <div class="skeleton-bar skeleton-line" *ngFor="let row of rowsArray()"></div>
    </div>
</div>
